
import { NormalIdlePresentation } from "./NormalIdlePresentation";
import { StartPresentation } from "../../presentations/general/StartPresentation";
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { WaysCounter } from "../../independent/countup/WaysCounter";
import { MathHelper } from "../../../dev/utils/MathHelper";
import { RoadRage } from '../../RoadRage';
import { ReelEngineController } from "../../../dev/reel/ReelEngineController";
import { RoadRageReelOverlay } from '../../reel/RoadRageReelOverlay';
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';

export class NormalStartPresentation extends StartPresentation {

    protected willChangeSize: boolean = false;
    protected layoutChanging: boolean = false;

    protected isNormalStart:boolean = true;

    preStart(): void {
        super.preStart();
        this.normalStart();
    }

    private normalStart():void{

        this.layoutChanging = false;
        RoadRage.reelManager.applyMask(true);
        this.willChangeSize = RoadRageEngineManager.wantsToSwitch;

        if(this.isNormalStart)
            NormalIdlePresentation.DisableNormalIdle(this.willChangeSize);

        if(!this.willChangeSize)
            WaysCounter.instance.setValue(undefined, MathHelper.WaysCount(RoadRageEngineManager.AllReels.length, RoadRageEngineManager.preferedLayoutSize), 0.25);

    }

    createPresentation() {
        this.startReels();
        if (!this.needToChangeLayout(RoadRageEngineManager.preferedLayoutSize))
            this.PresentationState.setInactive();
    }

    addExtraForStart(reel: ReelEngineController): void {
        reel.setGraphAlpha(0.25,reel.startDuration);
    }

    private needToChangeLayout(amountOfSyms: number): boolean {

        if(RoadRage.backgroundElements.wantsToReset){
            this.timeline.add(RoadRage.backgroundElements.playNormalSwitch(true,1),0);
            this.willChangeSize = false;
        }else if (this.willChangeSize) {
            if (!this.addStartReelOffset()) { // When Start is done.
                if (this.changeLayout(amountOfSyms)){
                    this.willChangeSize = false;
                    RoadRage.reelManager.miniCovering(true);
                }
                    
            }
        }
        return this.willChangeSize;
    }

    private changeLayout(amountOfSyms: number): boolean {

        if (this.layoutChanging) return !RoadRageEngineManager.isAnyoneChangingLayout;

        const reelChangeDurr:number = 0.75;

        const fromLeft:boolean = RoadRage.reelManager.currAmountReelSize > RoadRageEngineManager.preferedLayoutSize;

        RoadRage.reelManager.switchBgMovement(reelChangeDurr,fromLeft);

        RoadRageEngineManager.RAll(r => r.ChangeReelAreaAndSymbol(amountOfSyms,reelChangeDurr));

        RoadRage.bgOverlay.switchBgMovement(reelChangeDurr,fromLeft);
        RoadRageReelOverlay.instance.switchBgMovement(reelChangeDurr,fromLeft);

        RoadRageReelOverlay.instance.reelSizeChange(amountOfSyms, RoadRageEngineManager.preferedSymSize)
        WaysCounter.instance.setValue(undefined, MathHelper.WaysCount(RoadRageEngineManager.AllReels.length, RoadRageEngineManager.preferedLayoutSize), reelChangeDurr);
        RoadRage.backgroundElements.setNewBackground(amountOfSyms,reelChangeDurr,!fromLeft)
        SoundManager.playSoundEffect(SoundConfig.MAP_TRANSITIONS);
        this.layoutChanging = true;

        this.timeline.to(this,{duration:reelChangeDurr},0);
        
        return false;
    }

    skip(): void {
        // RoadRageEngineManager.isQuickStop = true;
    }

    done(): void {
    }
}